import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Text uses the phone's own system font (see --font-ui in styles.css): nothing to download.
import "./styles.css";
import "./components/focus.css";
import "./tactile.css";
import { App } from "./App";
import { applyStoredTheme } from "./lib/theme";
import { applyStoredTextSize } from "./lib/textSize";
import { reportClientError } from "./components/ErrorBoundary";
import { preloadStoredLang } from "./lib/i18n";

applyStoredTheme();
applyStoredTextSize();
// Errors outside React (timers, promises) go to the server log too, so problems on real phones can be found.
window.addEventListener("error", (e) => reportClientError(String(e.message), String(e.error?.stack ?? "")));
window.addEventListener("unhandledrejection", (e) => reportClientError(String(e.reason?.message ?? e.reason), String(e.reason?.stack ?? "")));
// A language that comes as its own file is fetched first (briefly, at most 1.5 s), so the app opens in it.
Promise.race([preloadStoredLang(), new Promise((r) => setTimeout(r, 1500))]).then(() =>
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
